import ApiService from '../../../../../services/ApiService'

export default {
  props: {
    title: String,
    institution: Object,
  },

  created() {
    this.getTimezones()

    this.user = JSON.parse(localStorage.getItem('user'))
    this.loggedInstitution = JSON.parse(localStorage.getItem('institution'))

    if (this.institution) {
      this.currentInstitution = this.institution

      console.log(this.currentInstitution)

      this.currentInstitution.locale = this.institution.locale
        ? this.institution.locale
        : 'pt'

      this.currentInstitution.currencyLocale = this.institution.currencyLocale
        ? this.institution.currencyLocale
        : 'pt-BR'

      this.currentInstitution.defaultFootnote = this.currentInstitution
        .calibrationFootNote
        ? this.currentInstitution.calibrationFootNote
        : `EQUIPACARE SERVICOS ESPECIALIZADOS DE APOIO TECNICO LTDA CNPJ: 17.040.595/0001-01
Endereço: R. 41-C, 611 - Vila Santa Cecília, Volta Redonda - RJ, 27255-430
Telefone: (24) 3348-7157`

      this.selectedImage = this.currentInstitution.logoPath
      this.filename = this.currentInstitution.logoFilename
      this.extension = this.currentInstitution.logoExtension

      this.inputDisabled = this.institution.status == 1
      this.isEditing = true

      this.currentInstitution.modules =
        this.currentInstitution.modules &&
        typeof this.currentInstitution.modules === 'string'
          ? this.currentInstitution.modules.split(',')
          : []

      this.modules = this.modules.map((x) => {
        const active =
          this.currentInstitution.modules &&
          this.currentInstitution.modules.includes(x.value)
        const updated = { ...x, active }
        if (x.subModules) {
          const hasAnySubModuleValue = x.subModules.some(
            (s) =>
              this.currentInstitution.modules &&
              this.currentInstitution.modules.includes(s.value)
          )
          updated.subModules = x.subModules.map((sub) => {
            const isStored =
              this.currentInstitution.modules &&
              this.currentInstitution.modules.includes(sub.value)
            // Sub-modules that default to inactive are opt-in only: they must be
            // explicitly stored to be active, never auto-enabled by the legacy
            // (no sub-module values) fallback below.
            if (sub.active === false) {
              return { ...sub, active: !!(active && isStored) }
            }
            return {
              ...sub,
              active: !active ? false : !hasAnySubModuleValue || isStored,
            }
          })
        }
        return updated
      })
    }
  },

  data: () => ({
    modules: [
      {
        icon: 'equips.svg',
        title: 'Equipamentos',
        active: true,
        value: 'equipamentos',
      },
      {
        icon: 'servOrder.svg',
        title: 'Ordem de Serviço',
        active: true,
        value: 'ordem_de_servico',
      },
      {
        icon: 'contracts.svg',
        title: 'Repositório Central de Arquivos',
        active: true,
        value: 'filesRepository',
      },
      {
        icon: 'called.svg',
        title: 'Chamados',
        active: true,
        value: 'chamados',
      },
      {
        icon: 'tools.svg',
        title: 'Manutenção Programada',
        active: true,
        value: 'manutencao_programada',
        subModules: [
          { title: 'Checklist', value: 'checklist', active: true },
          { title: 'Calibração', value: 'calibracao', active: true },
          { title: 'Segurança Elétrica', value: 'seguranca_eletrica', active: true },
        ],
      },
      {
        isIcon: true,
        icon: 'mdi-water-outline',
        title: 'Controle de Consumo',
        active: true,
        value: 'controle_de_consumo',
      },
      {
        icon: 'avoidedcost.svg',
        title: 'Custo Evitado',
        active: true,
        value: 'custo_evitado',
        subModules: [
          { title: 'Custo Evitado Unitário', value: 'custo_evitado_unitario', active: true },
          { title: 'Custo Evitado Recorrente', value: 'custo_evitado_recorrente', active: true },
          { title: 'Relatórios', value: 'custo_evitado_relatorios', active: true },
        ],
      },
      {
        icon: 'reports.svg',
        title: 'Relatórios',
        active: true,
        value: 'relatorios',
        subModules: [
          { title: 'Logs', value: 'relatorios_logs', active: true },
          { title: 'Dashboard', value: 'relatorios_dashboard', active: true },
          { title: 'Dashboard - BI', value: 'relatorios_dashboard_bi', active: true },
          { title: 'Dashboard Sintético', value: 'relatorios_dashboard_sintetica', active: false },
          { title: 'Indicadores', value: 'relatorios_indicadores', active: true },
          { title: 'Estudo de Substituição', value: 'relatorios_estudo_substituicao', active: true },
          { title: 'Alertas de Tecnovigilância', value: 'relatorios_tecnovigilancia', active: true },
        ],
      },
      {
        icon: 'calendar.svg',
        title: 'Agendamentos',
        active: true,
        value: 'agendamentos',
        subModules: [
          { title: 'Calendário', value: 'agendamentos_calendario', active: true },
          { title: 'Cronograma', value: 'agendamentos_cronograma', active: true },
          { title: 'Central de Equipamentos', value: 'agendamentos_central', active: true },
        ],
      },
      {
        icon: 'big-data.svg',
        title: 'Big Data',
        active: true,
        value: 'big_data',
        subModules: [
          { title: 'Dados', value: 'big_data_dados', active: true },
          { title: 'Dashboard', value: 'big_data_dashboard', active: true },
        ],
      },
      {
        icon: 'patchnotes.svg',
        title: 'Notas de atualização',
        active: true,
        value: 'notas_de_atualizacao',
      },
      {
        icon: 'users.svg',
        title: 'Usuários',
        active: true,
        value: 'users',
      },
      {
        icon: 'stock.svg',
        title: 'Estoque',
        active: true,
        value: 'estoque',
      },
      {
        icon: 'import.svg',
        title: 'Importar Equipamentos',
        active: true,
        value: 'importar_equipamentos',
        subModules: [
          { title: 'Importar Equipamentos', value: 'importar_equip', active: true },
          { title: 'Importar Setor', value: 'importar_setor', active: true },
          { title: 'Importar Subsetor', value: 'importar_subsetor', active: true },
        ],
      },
      {
        icon: 'supplier.svg',
        title: 'Fornecedores',
        active: true,
        value: 'fornecedores',
      },
      {
        icon: 'contracts.svg',
        title: 'Contratos',
        active: true,
        value: 'contratos',
      },
      {
        icon: 'tasks.svg',
        title: 'Tarefas',
        active: true,
        value: 'tarefas',
      },
    ],
    selectedImage: '',
    extension: '',
    filename: '',
    user: {},
    timezones: [],
    currencies: [
      {
        text: 'Reais (R$)',
        value: 'pt-BR',
      },
      {
        text: 'Pesos',
        value: 'es-CO',
      },
      {
        text: 'Euro',
        value: 'es-ES',
      },
    ],
    loading: false,
    step: 0,
    errorMessage: '',
    firstValid: true,
    error: false,
    isEditing: false,
    changedData: false,
    alterDialog: false,
    inputDisabled: false,
    currentInstitution: {
      name: '',
      initials: '',
      cnpj: '',
      observation: '',
      workshopType: '',
      timezone: '',
      locale: 'pt',
      currencyLocale: 'pt-BR',
    },
    departmentTypes: [
      { text: 'Engenharia clínica', value: 0 },
      { text: 'Manutenção predial', value: 1 },
    ],
    nameRules: [
      (v) => !!v || 'Nome requerido',
      (v) => (v && v.length <= 128) || 'Nome deve ter no máximo 128 caracteres',
    ],
    initialsRules: [
      (v) => !!v || 'Sigla requerida',
      (v) => (v && v.length <= 10) || 'Sigla deve ter no máximo 10 caracteres',
    ],
    workshopTypeRules: [(v) => !!v || 'Oficina requerida'],
    apiService: new ApiService(),
    loggedInstitution: {},
  }),

  computed: {
    isRestrictedUser() {
      return this.loggedInstitution.userType != 0
    },

    currentTitle() {
      switch (this.step) {
        case 0:
          return 'Dados Gerais'
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },

    showPops: {
      get() {
        const types = this.currentInstitution.departmentTypes || []
        return (
          (types.includes(0) && !!this.currentInstitution.showEngClinic) ||
          (types.includes(1) && !!this.currentInstitution.showEngInfra)
        )
      },
      set(value) {
        const types = this.currentInstitution.departmentTypes || []
        this.$set(this.currentInstitution, 'showEngClinic', value && types.includes(0))
        this.$set(this.currentInstitution, 'showEngInfra', value && types.includes(1))
      },
    },
  },

  methods: {
    removeDepartmentTypes(item) {
      if (this.isRestrictedUser) return

      this.institution.departmentTypes.splice(
        this.institution.departmentTypes.indexOf(item),
        1
      )
      this.institution.departmentTypes = [...this.institution.departmentTypes]
    },

    picImage() {
      document.getElementById('inst-logo').click()
    },

    setImage(image) {
      if (image.size > 2000000) {
        this.$toast.warning(
          'Só é permitido envio de imagens com no máximo 2mb!'
        )
      } else {
        const reader = new FileReader()
        reader.readAsDataURL(image)
        reader.onload = (event) => {
          this.selectedImage = event.target.result
          this.filename = image.name
          this.extension =
            image.name.split('.')[image.name.split('.').length - 1]
        }
      }
    },

    getTimezones() {
      this.apiService.get('timezone').then((response) => {
        this.timezones = response.content
      })
    },

    uppercase() {
      this.currentInstitution.initials =
        this.currentInstitution.initials.toUpperCase()
    },

    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$emit('close')
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    validarCNPJ(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g, '')

      if (cnpj == '') return false

      if (cnpj.length != 14) return false

      // Elimina CNPJs invalidos conhecidos
      if (
        cnpj == '00000000000000' ||
        cnpj == '11111111111111' ||
        cnpj == '22222222222222' ||
        cnpj == '33333333333333' ||
        cnpj == '44444444444444' ||
        cnpj == '55555555555555' ||
        cnpj == '66666666666666' ||
        cnpj == '77777777777777' ||
        cnpj == '88888888888888' ||
        cnpj == '99999999999999'
      )
        return false

      // Valida DVs
      let tamanho = cnpj.length - 2
      let numeros = cnpj.substring(0, tamanho)
      let digitos = cnpj.substring(tamanho)
      let soma = 0
      let pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) pos = 9
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
      if (resultado != digitos.charAt(0)) return false

      tamanho = tamanho + 1
      numeros = cnpj.substring(0, tamanho)
      soma = 0
      pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) pos = 9
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
      if (resultado != digitos.charAt(1)) return false

      return true
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.submit()
        }
      } else {
        this.close()
      }
    },

    async submit() {
      this.loading = true

      const types = this.currentInstitution.departmentTypes || []
      if (!types.includes(0)) this.currentInstitution.showEngClinic = false
      if (!types.includes(1)) this.currentInstitution.showEngInfra = false
      if (!types.length) this.currentInstitution.showManuais = false

      const activeValues = []
      this.modules.forEach((x) => {
        if (x.active) {
          activeValues.push(x.value)
          if (x.subModules) {
            x.subModules.filter((s) => s.active).forEach((s) => activeValues.push(s.value))
          }
        }
      })
      this.currentInstitution.modules = activeValues.join(',')

      const institution = {
        ...this.currentInstitution,
        logoPath: this.selectedImage,
        logoExtension: this.extension,
        logoFilename: this.filename,
      }

      let url = 'institution/add'

      if (this.isEditing) {
        url = 'institution/edit'
      }

      await this.apiService
        .post(url, institution)
        .then((response) => {
          const actualInstitution = JSON.parse(
            localStorage.getItem('institution')
          )

          if (actualInstitution.id == institution.id) {
            const institution = response.content
            institution.userType = actualInstitution.userType
            localStorage.removeItem('institution')
            localStorage.setItem('institution', institution)
            this.$store.commit(
              'SET_INSTITUTION_USER',
              JSON.stringify(institution)
            )
            this.$root.$emit('update')
          }

          this.step++
        })
        .catch((err) => {
          console.log(err)
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
      this.changedData = false
    },

    async getInstitution(institutionId) {
      const user = JSON.parse(localStorage.getItem('user'))

      await this.apiService
        .get(`institution/${institutionId}`)
        .then((response) => {
          const institution = response.content
          institution.userType = this.institution.userType

          if (user && user.mainType) {
            institution.userType = user.mainType
          }

          localStorage.removeItem('institution')
          localStorage.setItem('institution', institution)
          this.$store.commit(
            'SET_INSTITUTION_USER',
            JSON.stringify(institution)
          )
          this.$root.$emit('update')
        })
    },
  },

  watch: {
    'currentInstitution.departmentTypes'(types = []) {
      if (!types.includes(0)) this.$set(this.currentInstitution, 'showEngClinic', false)
      if (!types.includes(1)) this.$set(this.currentInstitution, 'showEngInfra', false)
      if (!types.length) this.$set(this.currentInstitution, 'showManuais', false)
    },
    currentInstitution: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
